var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.role_grade == 99)?_c('div',[_c('systemAdminHome')],1):(_vm.role_grade == 96)?_c('div',[_c('educationHome')],1):(_vm.role_grade == 95)?_c('div',{staticClass:"boss"},[_c('statistics'),_vm._v(" "),_c('div',{staticClass:"item"},[_c('echartsData')],1)],1):(_vm.role_grade != '')?_c('div',[_c('defaultPage')],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64192b63","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home.vue
// module id = null
// module chunks = 